// extracted by mini-css-extract-plugin
export default {"container":"layout_container__ThnfZ","child":"layout_child__xOL9g"};